export default __webpack_public_path__ + "static/media/gotowkaWhite.3a77cf5d.svg";